// removed by extract-text-webpack-plugin
module.exports = {"content":"c-ShippingCountry__content"};